<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Change Log</h3>

            <div class="search_bar mb-3">
                <b-row>
                    <b-col cols="2" class="pr-1">
                        <b-form-select
                            size="sm"
                            v-model="search_criteria.function_selected"
                            :options="function_options"
                        />
                    </b-col>

                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-select
                            size="sm"
                            v-model="search_criteria.user_selected"
                            :options="user_options"
                        />
                    </b-col>
                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="date"
                            v-model="search_criteria.start_at"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="2" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="date"
                            v-model="search_criteria.end_at"
                        ></b-form-input> </b-col
                    >

                    <!-- <b-col cols="3" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="text"
                            placeholder="Name/Username/Phone"
                            v-model="search_criteria.keyword"
                        ></b-form-input>
                    </b-col> -->

                    <b-col>
                        <b-button
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="onSearch"
                        >
                            <font-awesome-icon
                                class="mr-1"
                                icon="search"
                            />Search
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(ref_id)="data">
                    {{ data.item.ref_id || "-" }}
                </template>
                <template v-slot:cell(action)="data">
                    {{ data.item.action || "-" }}
                </template>
                <template v-slot:cell(field_name)="data">
                    {{ data.item.field_name || "-" }}
                </template>
                
            </b-table>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
                <div class="d-block">
                    <b-row class="mb-3">
                        <b-col>Are you sure to delete this user?</b-col>
                    </b-row>
                </div>
                <div class="text-right">
                    <b-btn
                        class="mt-3"
                        variant="outline-danger"
                        @click="hideModal_confirmDelete"
                        >Cancel</b-btn
                    >
                    <b-btn
                        class="mt-3"
                        variant="outline-success"
                        @click="deleteUser()"
                        >Confirm</b-btn
                    >
                </div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "function_name",
        label: "Function Name"
    },
    {
        key: "action",
        label: "Action"
    },
    {
        key: "ref_id",
        label: "Ref ID"
    },
    {
        key: "field_name",
        label: "Field Name"
    },
    {
        key: "from_value",
        label: "From Value"
    },
    {
        key: "to_value",
        label: "To Value"
    },
    {
        key: "created_at",
        label: "Created At"
    },
    {
        key: "created_by_name",
        label: "Created By"
    }
];

export default {
    name: "ProductMaster",
    mixins: [global_function],
    inject: [
        "API_HOST",
        "TABLE_LIMIT",
        "PAGING_LIMIT",
        "DEFAULT_ROWS_PER_PAGE"
    ],
    components: {
        Pagination
    },
    data() {
        return {
            upload_file: [],
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            //   table_offset: 0,
            total_rows: 0,
            rows_per_page: this.DEFAULT_ROWS_PER_PAGE,
            paging_limit: this.PAGING_LIMIT,
            search_criteria: {
                keyword: "",
                function_selected: null,
                user_selected: null,
                start_at: moment()
                    .subtract(6, "months")
                    .format("YYYY-MM-DD"),
                end_at: moment().format("YYYY-MM-DD")
            },
            function_options: [
                {
                    value: null,
                    text: "All Functions"
                }
            ],
            user_options: [
                {
                    value: null,
                    text: "All Users"
                }
            ]
        };
    },
    async created() {
        if (
            !this.checkPermission(
                this.$store.state.user_obj,
                "Account",
                "Account",
                "View",
                true
            )
        ) {
            this.$router.replace("/");
            return;
        }

        await this.getUsers();
        await this.getChangeLogs();
        this.initialized = true;
    },
    mounted() {
        if (
            !this.checkPermission(
                this.$store.state.user_obj,
                "Account",
                "Account",
                "View",
                true
            )
        ) {
            return;
        }

        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    computed: {
        table_offset: function() {
            return (this.currentPage - 1) * this.rows_per_page;
        }
    },
    methods: {
        async getUsers() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_user_get.php",
                data: {
                    offset: this.table_offset,
                    limit: 9999,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.user_options = [
                {
                    value: null,
                    text: "All Users"
                },
                ...response.data.users.map(u => ({
                    value: u.id,
                    text: `(${u.id}) ${u.name}`
                }))
            ];
            this.loader.hide();
        },

        async getChangeLogs() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "change_log_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.rows_per_page,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.items = response.data.change_logs;
            this.total_rows = parseInt(response.data.total_rows);

            this.function_options = [
                {
                    value: null,
                    text: "All Functions"
                }
            ];

            for (let i in response.data.functions) {
                let function_obj = {
                    value: response.data.functions[i],
                    text: response.data.functions[i]
                };

                this.function_options.push(function_obj);
            }
        },

        onSearch() {
            this.getChangeLogs();
        },

        onPageChange(page_to_change) {
            this.currentPage = page_to_change;
            this.getChangeLogs();
        },

        onPerPageChange(_perPage) {
            this.currentPage = 1;
            this.rows_per_page = _perPage;
            this.getChangeLogs();
        },

        showModal_confirmDelete(item) {
            this.$refs.modal_confirmDelete.item = item;
            this.$refs.modal_confirmDelete.show();
        },

        hideModal_confirmDelete() {
            this.$refs.modal_confirmDelete.hide();
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsChangeLog.vue